export default {
  error: 'Greška pri izvozu podataka: {{details}}',
  optionNotCompatibleWithDataImport: 'Nije kompatibilno sa uvozom podataka',
  options: {
    header: '$t(common.options)',
    fileFormatLabel: 'Format fajla',
    fileFormat: {
      csv: 'CSV',
      xlsx: 'Excel',
    },
    includeCategoryItemsLabels: 'Uključi oznake stavki kategorija',
    includeCategories: 'Uključi kategorije',
    expandCategoryItems: 'Proširi stavke kategorija',
    exportSingleEntitiesIntoSeparateFiles: 'Izvezi pojedinačne entitete u zasebne fajlove',
    includeAncestorAttributes: 'Uključi atribute nadređenih entiteta',
    includeAnalysis: 'Uključi promjenljive rezultata',
    includeDataFromAllCycles: 'Uključi podatke iz svih ciklusa',
    includeDateCreated: 'Uključi datum kreiranja',
    includeFiles: 'Uključi fajlove',
    includeFileAttributeDefs: 'Uključi kolone atributa fajla',
    includeInternalUuids: 'Uključi interne UUID-ove',
    recordsModifiedAfter: 'Zapisi izmijenjeni poslije',
    recordsModifiedBefore: 'Zapisi izmijenjeni prije',
  },
  optionsInfo: {
    expandCategoryItems:
      'dodaje po jednu logičku kolonu za svaku stavku kategorije, sa vrijednošću TRUE ako je stavka izabrana, a FALSE u suprotnom',
    exportSingleEntitiesIntoSeparateFiles: `izvozi pojedinačne entitete u zasebne fajlove; kada nije označeno, atributi koji pripadaju pojedinačnom entitetu biće uključeni među atribute njegovog najbližeg nadređenog višestrukog entiteta`,
    includeAnalysis: 'uključuje atribute analize',
    includeAncestorAttributes: 'uključuje atribute koji pripadaju nadređenim entitetima, sve do korijenskog entiteta',
    includeCategoryItemsLabels: 'dodaje kolonu sa oznakom za svaku stavku kategorije',
    includeCategories: `kategorije će biti izvezene u podfolder pod nazivom "categories"`,
    includeDataFromAllCycles: 'biće uključeni podaci iz svih ciklusa, u suprotnom samo iz izabranog',
    includeDateCreated: 'uključuje datum kreiranja svakog entiteta (reda) u koloni pod nazivom "date_created"',
    includeFiles: `izvozi fajlove povezane sa zapisima u podfolder pod nazivom "files"`,
    includeFileAttributeDefs: `dodaje kolone atributa fajla: interni identifikator fajla (file_uuid) i naziv (file_name)`,
    includeInternalUuids: 'uključuje interne identifikatore (UUID) u kolonama koje se završavaju sufiksom "_uuid"',
    recordsModifiedAfter: 'izvozi samo podatke iz zapisa izmijenjenih poslije navedenog datuma',
    recordsModifiedBefore: 'izvozi samo podatke iz zapisa izmijenjenih prije navedenog datuma',
  },
  startExport: 'Pokreni izvoz',
}
